import {useIntl} from "react-intl";
import styles from "./ContextMenu.module.css";

type ContextMenuProps = {
    onSetDropoff: () => void;
    onSetPickup: () => void;
    isFixedPickup?: boolean;
    isFixedDestination?: boolean;
    position: {x: number; y: number};
    visible: boolean;
};

export function ContextMenu({
    onSetDropoff,
    onSetPickup,
    isFixedPickup,
    isFixedDestination,
    position,
    visible,
}: ContextMenuProps) {
    const intl = useIntl();

    if (!visible) return null;

    return (
        <div className={styles.wrapper} style={{top: `${position.y}px`, left: `${position.x}px`}}>
            {!isFixedPickup && (
                <div className={styles.item} onClick={onSetPickup}>
                    {intl.formatMessage({id: "set_pickup_here"})}
                </div>
            )}
            {!isFixedDestination && (
                <div className={styles.item} onClick={onSetDropoff}>
                    {intl.formatMessage({id: "set_destination_here"})}
                </div>
            )}
        </div>
    );
}
